import React from "react";
import { useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {Avatar, Button, Dropdown, Menu, Popover} from "antd";
import {userSignOut} from "../../appRedux/actions";
import {DownOutlined, ShopFilled, PoweroffOutlined, UpOutlined} from "@ant-design/icons";
import {FaUser, FaChartBar} from "react-icons/fa";
import { MdManageAccounts, MdGroupAdd, MdGroups2, MdAccountBalance,
    MdFactCheck, MdContactMail, MdCastForEducation, MdPieChart,
    MdSettingsSuggest, MdMiscellaneousServices
 } from "react-icons/md";
 import { AiOutlineBars } from "react-icons/ai";
import {
    ACCOUNT_URL,
    ADMIN_URL, CRM_URL,
    ESM_URL, MANAGEMENTS_URL,
    PAYROLL_URL,
    RECRUITMENT_URL,
    SELF_SERVICE_URL,
    GET_ACTIVE_PROFILE_VERIFICATION
} from "../../constants/ServerUrl";
import "../../userprofile.css";

const UserProfile = () => {
    const dispatch = useDispatch();
    const {token, authorizations} = useSelector(({auth}) => auth);
    const currentUrl = window.location.href;
    const [moduleDropdownOpen, setModuleDropdownOpen] = useState(false);

    // const menu = (
    //     <Menu className="bg-blue-300 bg-opacity-75  pt-6 pl-1">
    //         <Menu.Item key="0">
    //            <div>
    //                <ShopFilled className="text-white text-lg"/>
    //                <span className="pl-10 align-middle text-white font-semibold">Settings</span>
    //            </div>

    //         </Menu.Item>

    //         <Menu.Divider/>
    //         <Menu.Item key="1">
    //             <div className="cursor-pointer" onClick={()=>{
    //                 dispatch(userSignOut());
    //             }}>
    //                 <PoweroffOutlined  className="text-white text-lg"/>

    //                 <span className="pl-10 align-middle text-white font-semibold">Sign out</span>
    //             </div>

    //         </Menu.Item>
    //     </Menu>
    // );

    const menu = (
        <Menu className="bg-blue text-center py-2 absolute w-full module-menu h-96"
            onClick={() => {
                const mainMenu = document.querySelector(".main-menu");
                if (mainMenu) {
                    mainMenu.classList.toggle("hidden");
                }
            }}
        >
            <Menu.Item key="self-service" className={currentUrl.includes(SELF_SERVICE_URL) && "hidden"}>
               <div className="flex cursor-pointer items-center mt-5 text-white text-base font-medium" onClick={() => {
                        window.location.href = SELF_SERVICE_URL + "?referer=" + token;
                    }}
                >
                   <MdManageAccounts className="text-xl md:text-2xl"/>
                   <span className="align-middle mx-4 py-1">Self-Service</span>
               </div>
            </Menu.Item>

            {authorizations[8] && authorizations[8].view.length > 0 &&
                (
                    <Menu.Item key="esm" className={currentUrl.includes(ESM_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = ESM_URL + "?referer=" + token;
                            }}
                        >
                            <MdGroups2 className="text-xl md:text-2xl"/>
                            <span className="align-middle ml-4 py-1 w-max">Employees</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[4] && authorizations[4].view.length > 0 &&
                (
                    <Menu.Item key="recruitment" className={currentUrl.includes(RECRUITMENT_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = RECRUITMENT_URL + "?referer=" + token;
                            }}
                        >
                            <MdGroupAdd className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">Recruitment</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[2] && authorizations[2].view.length > 0 &&
                (
                    <Menu.Item key="accounting" className={currentUrl.includes(ACCOUNT_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = ACCOUNT_URL + "?referer=" + token;
                            }}
                        >
                            <MdAccountBalance className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">Accounting</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[2] && authorizations[2].view.length > 0 &&
                (
                    <Menu.Item key="payroll" className={currentUrl.includes(PAYROLL_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = PAYROLL_URL + "?referer=" + token;
                            }}
                        >
                            <MdFactCheck className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">Payroll</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[2] && authorizations[2].view.length > 0 &&
                (
                    <Menu.Item key="invoicing" className="hidden">
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                // window.location.href = ACCOUNT_URL + "?referer=" + token;
                            }}
                        >
                            {/* <AiFillAccountBook className="text-xl md:text-2xl"/> */}
                            <span className="align-middle mx-4 py-1">Invoicing</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[10] && authorizations[10].view.length > 0 &&
                (
                    <Menu.Item key="crm" className={currentUrl.includes(CRM_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = CRM_URL + "?referer=" + token;
                            }}
                        >
                            <MdContactMail className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">CRM</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[2] && authorizations[2].view.length > 0 &&
                (
                    <Menu.Item key="lms" className="hidden">
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                // window.location.href = ACCOUNT_URL + "?referer=" + token;
                            }}
                        >
                            <MdCastForEducation className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">LMS</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[2] && authorizations[2].view.length > 0 &&
                (
                    <Menu.Item key="productivity" className="hidden">
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                // window.location.href = ACCOUNT_URL + "?referer=" + token;
                            }}
                        >
                            <FaChartBar className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">Productivity</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[7] && authorizations[7].view.length > 0 &&
                (
                    <Menu.Item key="settings" className={currentUrl.includes(ADMIN_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = ADMIN_URL + "?referer=" + token;
                            }}
                        >
                            <MdSettingsSuggest className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1 w-max">Company Settings</span>
                        </div>
                    </Menu.Item>
                )
            }

            {authorizations[9] && authorizations[9].view.length > 0 &&
                (
                    <Menu.Item key="operations" className={currentUrl.includes(MANAGEMENTS_URL) && "hidden"}>
                        <div className="flex cursor-pointer items-center mt-3 text-white text-base font-medium"
                            onClick={() => {
                                window.location.href = MANAGEMENTS_URL + "?referer=" + token;
                            }}
                        >
                            <MdMiscellaneousServices className="text-xl md:text-2xl"/>
                            <span className="align-middle mx-4 py-1">Operations</span>
                        </div>
                    </Menu.Item>
                )
            }
        </Menu>
    );


    return (
        Object.keys(authorizations).length > 1 && (
            <Dropdown trigger={["click"]} overlay={menu}
                onOpenChange={(open) => {
                    // console.log("open", open);
                    setModuleDropdownOpen(open);
                    const mainMenu = document.querySelector(".main-menu");
                    if (mainMenu) {
                        mainMenu.classList.toggle("hidden");
                    }
                }}
            >
                <Button
                    className="text-white font-semibold items-center justify-center space-x-3 focus:bg-blue-200 focus:bg-opacity-70 rounded w-full py-auto h-11 flex bg-opacity-70 bg-blue-200 hover:bg-blue-200  border-blue-200 hover:border-blue-200"
                    size="large">
                    <AiOutlineBars />
                    <span>MY APPS</span>
                    <div className="align-middle text-lg">
                        { moduleDropdownOpen ? (<UpOutlined/>) : (<DownOutlined/>) }
                    </div>
                </Button>
            </Dropdown>
        )
    )
};

export default UserProfile;
